import { IBreed, IProfile } from '@jumpstart/core';
import { Context, createContext, useContext } from 'react';
import { useLocation } from 'react-router-dom';
import { ITaxonomy } from './schemas';

// CONTEXTS
export const AdminProfileContext: Context<undefined | IProfile> = createContext<undefined | IProfile>(undefined);
export const IsAdminContext: Context<boolean> = createContext<boolean>(false);
export const BreedsContext: Context<IBreed[]> = createContext<IBreed[]>([]);
export const TaxonomyContext: Context<{ [id: string]: ITaxonomy }> = createContext<{ [id: string]: ITaxonomy }>({});

// Handlers
export const useAdminProfile = () => useContext(AdminProfileContext);
export const useIsAdmin = () => useContext(IsAdminContext);
export const useBreeds = () => useContext<IBreed[]>(BreedsContext);
export const useTaxonomy = () => useContext<{ [id: string]: ITaxonomy }>(TaxonomyContext);
export const useQuery = () => new URLSearchParams(useLocation().search);
